<template>
    <table class="table table-striped">
        <thead>
            <slot name="thead-pre" />
            <tr>
                <th>
                    <button v-if="editable" type="button" class="btn btn-default btn-xs" title="Nuova" @click="insert()">
                        <span class="glyphicon glyphicon-plus" />
                    </button>
                </th>
                <slot name="thead" />
            </tr>
            <template v-if="defaultsRow">
                <tr class="warning">
                    <td>
                        <b>Predefinito</b>
                        <input
                            v-if="checkboxes"
                            v-model="defaultRowDisabled"
                            type="checkbox"
                            class="table-selector"
                            :true-value="undefined"
                            :false-value="true"
                            @change="processDefaultCheckbox"
                        >
                    </td>
                    <template v-if="defaultsRow == 'custom'">
                        <slot name="defaults" :item="defaultData" :index="-1" />
                    </template>
                    <template v-if="defaultsRow == 'clone'">
                        <slot name="tbody" :item="defaultData" :index="-1" />
                    </template>
                </tr>
            </template>
        </thead>
        <tbody ref="tbody">
            <template v-for="(item, index) in data">
                <tr :key="index">
                    <td>
                        <button v-if="editable" type="button" class="btn btn-default btn-xs" title="Rimuovi" @click="remove(index)">
                            <span class="glyphicon glyphicon-remove" />
                        </button>
                        <input
                            v-if="checkboxes && !item.forceRowDisabled"
                            v-model="item.rowDisabled"
                            type="checkbox"
                            class="table-selector"
                            :true-value="undefined"
                            :false-value="true"
                        >
                    </td>
                    <slot name="tbody" :item="item" :index="index" />
                </tr>
            </template>
        </tbody>
    </table>
</template>

<script>
import Default from './bootstrap-table-form';

export default Default;
</script>
